export { ClipboardList as default } from './ClipboardList';
